var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEhLogo = function SvgEhLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_xA0_Image_00000061441164331287072840000005525581948453378210_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 148.8 23.5",
    style: {
      enableBackground: "new 0 0 148.8 23.5"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#EEB111;}\n\t.st1{fill:#490E67;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,0.9C25,2.1,20.5,4,16.2,6.8l0,0c-3.6,2.3-7,5.2-10.2,8.8c3.6,2,7,4.5,10.1,7.5c3.1-3,6.6-5.4,10.1-7.5 L29.8,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.2,0.9l3.7,14.8c3.3-3.6,6.7-6.5,10.2-8.8l0,0l0,0C11.8,3.9,7,2.1,2.2,0.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,18h-7.3V6.8h7.3v2h-5v2.6h4.4v1.9h-4.4V16h5V18L44.4,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.9,9c1.4,0,2.5,0.8,2.5,2.7V18h-2.3v-5.4c0-1-0.3-1.6-1.3-1.6c-0.8,0-1.6,0.5-1.6,2.2V18H51v-5.4 c0-1-0.3-1.6-1.2-1.6c-0.8,0-1.6,0.6-1.6,2.2V18h-2.3V9.2h1.9l0.3,1.7C48.5,9.6,49.5,9,50.8,9c1.2,0,2.1,0.5,2.3,1.9 C53.6,9.6,54.7,9,55.9,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.8,18h-1.6V5.3h2.3v5.6C62.9,9.5,64,9,65.3,9c2.1,0,3.4,1.6,3.4,4.4s-1.4,4.8-3.7,4.8 c-1.5,0-2.3-0.7-2.6-1.5L61.8,18z M62.5,14.4c0,1.6,1,2.1,1.8,2.1c1.2,0,2.1-0.9,2.1-3c0-1.9-0.7-2.8-2-2.8c-1,0-2,0.8-2,2.2 L62.5,14.4L62.5,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,17.9c-0.5,0.1-0.9,0.2-1.3,0.2c-1.2,0-2.3-0.6-2.3-2.1V5.3h2.3v10.1c0,0.5,0.3,0.8,0.8,0.8 c0.2,0,0.4,0,0.7-0.1L73.5,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,15.2l1.9,0.6c-0.4,1.8-2,2.4-3.7,2.4c-2.5,0-4.1-1.6-4.1-4.5c0-3,1.6-4.7,4.2-4.7c2.4,0,3.6,1.6,3.6,3.8 c0,0.4,0,0.8-0.1,1.2h-5.5c0,1.5,0.7,2.5,2,2.5C79.1,16.5,79.7,16.2,80,15.2z M79.8,12.7c0-0.1,0-0.2,0-0.3c0-0.9-0.5-1.6-1.6-1.6 c-1,0-1.7,0.8-1.8,2H79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.3,9c1.4,0,2.5,0.8,2.5,2.7V18h-2.3v-5.4c0-1-0.3-1.6-1.3-1.6c-0.8,0-1.6,0.5-1.6,2.2V18h-2.3v-5.4 c0-1-0.3-1.6-1.2-1.6c-0.8,0-1.6,0.6-1.6,2.2V18h-2.3V9.2h1.9l0.3,1.7C85.9,9.6,86.9,9,88.1,9c1.2,0,2.1,0.5,2.3,1.9 C91,9.6,92.1,9,93.3,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.8,18V6.8h2.3v4.5h4.7V6.8h2.3V18h-2.3v-4.7h-4.7V18L97.8,18L97.8,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.5,15.2l1.9,0.6c-0.4,1.8-2,2.4-3.7,2.4c-2.5,0-4.1-1.6-4.1-4.5c0-3,1.6-4.7,4.2-4.7 c2.4,0,3.6,1.6,3.6,3.8c0,0.4,0,0.8-0.1,1.2h-5.5c0,1.5,0.7,2.5,2,2.5C113.6,16.5,114.2,16.2,114.5,15.2z M114.2,12.7 c0-0.1,0-0.2,0-0.3c0-0.9-0.5-1.6-1.6-1.6c-1,0-1.7,0.8-1.8,2H114.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.5,15.5c0,0.6,0.3,0.8,0.6,0.8c0.2,0,0.3,0,0.5-0.1v1.7c-0.3,0.2-0.7,0.3-1.3,0.3c-1.1,0-1.8-0.4-2-1.4 c-0.4,1.1-1.4,1.5-2.6,1.5c-1.6,0-2.6-0.9-2.6-2.4c0-2,1.6-3,5-2.9v-0.9c0-0.8-0.4-1.3-1.2-1.3c-0.8,0-1.2,0.5-1.3,1.3l-2.2-0.4 c0.1-1.9,1.7-2.7,3.6-2.7c2,0,3.3,0.8,3.3,2.8V15.5L124.5,15.5z M122.2,14.2c-2,0-2.7,0.4-2.7,1.3c0,0.6,0.4,1,1.1,1 c0.7,0,1.6-0.4,1.6-1.3V14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.1,17.9c-0.5,0.1-0.9,0.2-1.3,0.2c-1.2,0-2.3-0.6-2.3-2.1V5.3h2.3v10.1c0,0.5,0.3,0.8,0.8,0.8 c0.2,0,0.4,0,0.7-0.1L130.1,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.6,17.6c-0.7,0.3-1.5,0.5-2.5,0.5c-1.7,0-2.8-0.8-2.8-2.7V11h-1.3V9.2h1.3V7.4l2.3-0.3v2.1h2.6V11h-2.6v4 c0,0.9,0.4,1.3,1.1,1.3c0.5,0,1-0.2,1.5-0.5L136.6,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.8,10.9c0.4-1.3,1.4-1.9,2.7-1.9c1.4,0,2.6,0.8,2.6,2.8V18h-2.3v-5.4c0-1-0.3-1.6-1.3-1.6 c-0.9,0-1.8,0.5-1.8,2.2V18h-2.3V5.3h2.3L139.8,10.9L139.8,10.9z"
  }))));
};
export { SvgEhLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/eh-logo.c33cee5f.svg";